import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomTable from "../../../Components/common/Table/CustomTable";
import DownloadIcon from "../../../Components/Icon-SVG/DownloadIcon";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";

import { hashesHeader } from "../../../utils/constants/tableHeaders";

import { RequestIocHashes } from "../../../store/actions/analysisReportActions";

import "./styles.scss";

const Hashes = () => {
  const [selectedTimeFilter, setSelectedTimeFilter] = useState(null);

  const iocHashes = useSelector((state) => state.analysisReports.iocHashes);
  const iocHashesLoading = useSelector((state) => state.analysisReports.iocHashesLoading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTimeFilter) {
      dispatch(RequestIocHashes(selectedTimeFilter));
    }
  }, [dispatch, selectedTimeFilter]);

  const downloadHashesHandler = () => {
    const blob = new Blob(
      [
        iocHashes
          .filter((el) => el.hash)
          .map((el) => el.hash)
          .join("\n"),
      ],
      {
        type: "plain/text",
      },
    );
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "CFSBOX_IOC_HASHes.txt";
    document.body.appendChild(a);
    a.click();

    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const isDisabled = iocHashes.length === 0 || iocHashesLoading;

  return (
    <div className="hashes">
      <div className="hashes__header">
        <h1>Hashes</h1>
        <div>
          <p>Below list is displaying hashes of malicious files and their malicious artifacts:</p>
          <button onClick={downloadHashesHandler} disabled={isDisabled}>
            Download Hashes
            <DownloadIcon
              width={18}
              color={isDisabled ? "var(--card-background-color)" : undefined}
            />
          </button>
        </div>
      </div>
      <div className="hashes__table border">
        <CustomTable
          exportFile={true}
          dataTable={iocHashes}
          tableName="hashes"
          column={hashesHeader}
          paginationButtons={true}
          className=""
          customPageSize={10}
          minHeight="585px"
          minBottom="5px"
          defaultPosition="relative"
          filterByTime={true}
          selectedTimeFilter={selectedTimeFilter}
          setSelectedTimeFilter={setSelectedTimeFilter}
          defaultFilterIndex={2}
        />
        <Backdrop show={iocHashesLoading} absolute={true} />
      </div>
    </div>
  );
};

export default Hashes;
